















































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import AnalysisMixin from "@/mixins/http/AnalysisMixin";
import { PolygonPopulation, ScoutingPlace } from "../../models";
import VContentLoading from "@/components/VContentLoading.vue";
import FormatNumber from "@/filters/FormatNumber";
import { currentScoutingStore } from "@/store/typed";
import Throttler from "@/utils/Throttler";
import ScoutingArea from "@/models/ScoutingArea";

@Component({
  components: { VContentLoading },
  filters: { FormatNumber },
})
export default class TotalData extends Mixins(AnalysisMixin) {
  private total: PolygonPopulation | null = null;
  @Prop({ required: true }) readonly isocronIds!: string[];
  @Prop({
    default: () => {
      return [];
    },
  })
  readonly areaIds!: string[];

  private throttler: Throttler = new Throttler();

  private loading = true;

  mounted() {
    this.load();
  }

  get payload() {
    return {
      granularity: "scouting",
      isocron_ids: this.isocronIds,
      area_ids: this.areaIds,
    };
  }

  @Watch("isocronIds")
  onIsocronIdsChanged() {
    this.throttler.run(() => this.load());
  }
  @Watch("areaIds")
  onAreaIdsChanged() {
    this.throttler.run(() => this.load());
  }
  async load() {
    this.loading = true;
    this.total = (await this.getPolygonPopulations(this.payload))?.[0];
    this.$emit("population", this.total?.population);
    this.loading = false;
  }
}
